import SituationAssessment from './SituationAssessment';
import './SituationAssessment.scss';

export default SituationAssessment;
